import { Component, OnInit, ViewChild } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { SpinnerService } from './services/spinner.service';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  showSpinner: boolean = false; // Controls spinner visibility

  constructor(
    private primengConfig: PrimeNGConfig,
    private spinnerService: SpinnerService,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.spinnerService.spinnerVisible$.subscribe((visible: boolean) => {
      this.showSpinner = visible;
    });
    
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      mergeMap(route => route.data)
    ).subscribe(data => {
      const pageTitle = data["title"] ? `PayNowConnect - ${data["title"]}` : 'PayNowConnect';
      this.titleService.setTitle(pageTitle);
    });
  }
}
